import {
	SET_VAR,
	CLEAR
} from "./sessionActionsCreator";
import menuItems from "../../components/Sidebar/_nav";

const defaultState = {
	menu:[menuItems.dashboard]
};

export default function sessionReducer(state = defaultState, action) {
	switch (action.type) {
		case SET_VAR: {
			let newState = {...state};
			newState[action.data.name] = action.data.value;
			return {
				...newState
			};
		}
		case CLEAR: {
			return defaultState;
		}
		default: return state;
	}
}